import { generateRecaptchaToken } from './generateRecaptchaToken';

const waitForRecaptcha = () => {
  let counter = 1;
  const poll = (resolve: (value: boolean) => void) => {
    if (window.grecaptcha?.isReady) {
      resolve(true);
    } else if (counter > 20) {
      resolve(false);
    } else {
      counter++;
      setTimeout(() => poll(resolve), 100);
    }
  };

  return new Promise(poll);
};

export const waitForAndGenerateRecaptchaToken = async (action: string) => {
  const successfulWait = await waitForRecaptcha();
  if (!successfulWait) {
    return { token: null, message: 'Could not initialise recaptcha' };
  }
  const token = await generateRecaptchaToken(window.Jbhifi.recaptchaSiteKey ?? '', action);
  if (!token)
    return {
      token: null,
      message: 'Could not generate recaptcha',
    };
  return { token };
};
